'use client';

import { Check } from 'lucide-react';
import Link from 'next/link';
import { motion } from 'framer-motion';

export default function PricingPage() {
  const plans = [
    {
      name: 'Starter',
      price: '10',
      description: 'Pour les buveurs occasionnels',
      features: [
        '2 réductions / jour',
        'Tarif Happy Hour bloqué',
        'Support standard'
      ],
      highlight: false,
    },
    {
      name: 'Regular',
      price: '20',
      description: 'Le choix préféré de nos membres',
      features: [
        '5 réductions / jour',
        'Tarif Happy Hour bloqué',
        'Événements exclusifs',
        'Support prioritaire'
      ],
      highlight: true,
    },
    {
      name: 'Premium',
      price: '35',
      description: 'Pour les fêtards professionnels',
      features: [
        'Réductions illimitées',
        'Tarif Happy Hour bloqué',
        'Coupe-file dans certains bars',
        'Conciergerie 24/7'
      ],
      highlight: false,
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-display font-bold mb-6">Des tarifs simples.<br/>Des économies géantes.</h1>
        <p className="text-xl text-surface-300">Choisis l'abonnement qui correspond à ta soif.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 items-center">
        {plans.map((plan, i) => (
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.15 }}
            key={plan.name} 
            className={`glass-card p-8 relative ${plan.highlight ? 'amber-glow border-amber-500/50 scale-105' : 'hover:border-glass-border/80'}`}
          >
            {plan.highlight && (
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-surface-950 font-bold px-4 py-1 rounded-full text-sm">
                POPULAR
              </div>
            )}
            <h3 className="text-2xl font-display font-bold mb-2">{plan.name}</h3>
            <div className="mb-4">
              <span className="text-4xl font-bold">{plan.price}€</span>
              <span className="text-surface-400"> / mois</span>
            </div>
            <p className="text-surface-300 mb-8">{plan.description}</p>
            
            <ul className="space-y-4 mb-8">
              {plan.features.map((feature, j) => (
                <li key={j} className="flex items-center gap-3">
                  <Check className="text-amber-500" size={20} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <Link href="/register" className={`block text-center py-3 rounded-xl font-bold transition-all ${plan.highlight ? 'bg-amber-500 text-surface-950 hover:bg-amber-400' : 'bg-surface-800 hover:bg-surface-700 text-white'}`}>
              Choisir ce plan
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="mt-24 text-center max-w-2xl mx-auto">
        <h2 className="text-3xl font-display font-bold mb-8">Questions fréquentes</h2>
        <div className="space-y-4">
          <div className="glass-card p-6 text-left">
            <h4 className="font-bold mb-2">Comment marche le cashback ?</h4>
            <p className="text-surface-300 text-sm">Nous détectons automatiquement tes dépenses chez nos partenaires via ta carte bancaire. La différence de prix t'est remboursée sous forme de cashback.</p>
          </div>
          <div className="glass-card p-6 text-left">
            <h4 className="font-bold mb-2">Puis-je annuler à tout moment ?</h4>
            <p className="text-surface-300 text-sm">Oui, tous nos abonnements sont sans engagement. Tu peux annuler en un clic depuis ton espace client.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
